import { useTrack } from "@/analytics/events";
import Section from "@/blueprint/components/Section/Section";
import CrossLinkBanner from "@/views/shared/CrossLinkBanner";
import { INNOVATION_BANNER } from "@/views/shop/shopContent";

// Separate so its `useTrack` sits below the section context Section provides.
const InnovationBannerLink = () => {
  const track = useTrack();

  return (
    <CrossLinkBanner
      href={INNOVATION_BANNER.href}
      onClick={() =>
        track("cta_clicked", {
          cta: "innovation",
          href: INNOVATION_BANNER.href,
        })
      }
      eyebrow={INNOVATION_BANNER.eyebrow}
      eyebrowSize="sm"
      title={INNOVATION_BANNER.title}
      images={INNOVATION_BANNER.images}
      imageAlt={INNOVATION_BANNER.imageAlt}
      mobileCard="top-column"
    />
  );
};

const InnovationBanner = ({ position }: { position: number }) => (
  <Section
    id="innovation-banner"
    position={position}
    className="px-grid-margin"
  >
    <InnovationBannerLink />
  </Section>
);

export default InnovationBanner;
